import * as React from "react";

const SvgArrowUpDown = props => <svg width={21} height={18} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.6507 4.95L9.26944 6.364L6.79214 3.828V17H4.83843V3.828L2.36211 6.364L0.979858 4.95L5.81529 0L10.6507 4.95ZM20.4193 13.05L15.5838 18L10.7484 13.05L12.1297 11.636L14.608 14.172L14.607 1H16.5607V14.172L19.038 11.636L20.4193 13.05Z" fill="#F8F8F8" /></svg>;

export default SvgArrowUpDown;